module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0166e482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/Spie.vue
// module id = 996
// module chunks = 0